import useSWR from 'swr';
import { type JwtPayload } from 'jwt-decode';
import { getAccessToken } from '@/services/access';
import { enqueueSnackbar } from '@/providers/SnackbarProvider';
import { loginMessages } from '@/components/private/messages';

export const useAccessToken = (azureAccessToken?: string) => {
  return useSWR(
    azureAccessToken ? '/api/Access/GetAccessToken' : null,
    async () => {
      const inviteGuid = localStorage.getItem('invite-guid');
      return await getAccessToken(azureAccessToken!, inviteGuid);
    },
    {
      revalidateOnFocus: false,
      onErrorRetry: (error, _key, _config, revalidate, { retryCount }) => {
        if (retryCount > 1) {
          enqueueSnackbar(
            loginMessages['login.fetchAccessToken.unexpctedError'],
            {
              variant: 'error',
            },
          );
          console.error('[BREEDLOGIC] <useAccessToken> error', error);
          return;
        }

        setTimeout(() => revalidate({ retryCount }), 1000);
      },
    },
  );
};

export interface DecodedEntraIdToken extends JwtPayload {
  emails: string[];
  given_name?: string;
  family_name?: string;
}

export interface DecodedAccessToken {
  AzureToken: string;
  UserEmail: string;
  UserGuid: string;
  UserName: string;
  UserId: string;
  System: string;
  AccessEntity: string;
  exp: number;
  iss: string;
  aud: string;
}
